module.exports = __webpack_public_path__ + "img/633-2c40df.png";